(() => {
  function init(root=document) {
    root.querySelectorAll('.dxp-v').forEach(section => {
      if (section.dataset.reviewBound) return;
      section.dataset.reviewBound='true';
      const row=section.querySelector('.dxp-v__row');
      const prev=section.querySelector('[data-dx-video-prev]');
      const next=section.querySelector('[data-dx-video-next]');
      const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
      const move=direction => row.scrollBy({left:direction*(row.firstElementChild.offsetWidth+18),behavior:reduced?'auto':'smooth'});
      const state=()=>{prev.disabled=row.scrollLeft<2;next.disabled=row.scrollLeft+row.clientWidth>=row.scrollWidth-2};
      prev.addEventListener('click',()=>move(-1)); next.addEventListener('click',()=>move(1));
      row.addEventListener('scroll',state,{passive:true});
      row.addEventListener('keydown',e=>{if(e.target===row && ['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();move(e.key==='ArrowLeft'?-1:1)}});
      new ResizeObserver(state).observe(row);state();
      row.querySelectorAll('[data-dxp-play]').forEach(card=>{
        const video=card.querySelector('video'),button=card.querySelector('.dxp-v__play');
        button.addEventListener('click',()=>{
          document.querySelectorAll('.dxp-v video').forEach(other=>{if(other!==video)other.pause()});
          video.controls=true;video.play().catch(()=>{video.controls=false;card.classList.remove('on')});
        });
        video.addEventListener('play',()=>card.classList.add('on'));
        video.addEventListener('pause',()=>{if(!video.controls)card.classList.remove('on')});
        video.addEventListener('ended',()=>{video.controls=false;card.classList.remove('on')});
        new IntersectionObserver(entries=>{if(!entries[0].isIntersecting)video.pause()},{threshold:.1}).observe(card);
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
